/**
 * notes to other devs, we are starting to move toward a 1.0.0
 * which will include making `/compiled` the default entry point
 * to the package.
 *
 * the previous version will be under `/depecated` until
 * we can clean up usage in the monorepo.
 */

import type { ForwardRefExoticComponent, RefAttributes } from 'react';

import type { BaseCellProps, SortDirection } from './ui/primitives/base-cell';
import { Table, type TableProps } from './ui/primitives/table';
import { TBody, type TBodyProps } from './ui/primitives/tbody';
import { TD } from './ui/primitives/td';
import { TH, type THProps } from './ui/primitives/th';
import { THead, type THeadProps } from './ui/primitives/thead';
import { TR, type TRProps } from './ui/primitives/tr';

export { ExpandIcon } from './ui/primitives/expand-icon';

export { TBody } from './deprecated/components/body';
export { DraggableCell } from './deprecated/components/cell-dnd';
export { HeadCell } from './deprecated/components/head-cell';
export { HeaderDescription } from './deprecated/components/header-description';
export { Row } from './deprecated/components/row';
export { RowCell } from './deprecated/components/row-cell';
export { SortIcon } from './deprecated/components/sort-icon';
export { Table } from './deprecated/components/table';
export { THead } from './deprecated/components/thead';

export {
	CharlieTable,
	type CharlieTableProps,
	TableState,
	type RowSpacing,
} from './deprecated/charlie-table';

export {
	useCharlieTable,
	type CharlieTableCell,
	type CharlieTableColumn,
	type CharlieTableHook,
	type CharlieTableRow,
	type CharlieTableState,
	type TableSortDirection,
} from './hooks/use-charlie-table';

export { useInfiniteScroll } from './shared-hooks/use-infinite-scroll';

export const Primitives: {
	TBody: ForwardRefExoticComponent<
		Omit<TBodyProps, 'ref'> & RefAttributes<HTMLTableSectionElement>
	>;
	THead: ForwardRefExoticComponent<
		Omit<THeadProps, 'ref'> & RefAttributes<HTMLTableSectionElement>
	>;
	TR: ForwardRefExoticComponent<Omit<TRProps, 'ref'> & RefAttributes<HTMLTableRowElement>>;
	Table: ForwardRefExoticComponent<Omit<TableProps, 'ref'> & RefAttributes<HTMLTableElement>>;
	TD: ForwardRefExoticComponent<Omit<BaseCellProps, 'as'> & RefAttributes<HTMLTableCellElement>>;
	TH: ForwardRefExoticComponent<
		Omit<
			THProps & {
				sortDirection?: SortDirection;
				ref?: React.RefObject<HTMLTableCellElement>;
			},
			'ref'
		> &
			RefAttributes<HTMLTableCellElement>
	>;
} = { TBody, THead, TR, Table, TD, TH };
